<template>
  <div class="edm-info">
    <div class="title">1. Отправлен код активации.</div>
    <div class="indent">
      <p>
        Вы должны распечатать заявку на присоединение, если не началось
        скачивание автоматически. Нажмите кнопку <b>"Скачать еще раз заявку"</b>
      </p>
      <p>
        У водителя должно быть установлено приложение PayControl. Если не
        установлено помогите установить.
      </p>
      <el-row :gutter="24">
        <el-col :span="16">
          <el-row>
            <p class="edm-desc edm-qr">
              Водитель должен отсканировать qr код на заявке
            </p>
          </el-row>
          <el-row>
            <p class="edm-desc edm-sms">
              Водитель должен ввести код активации который ему прийдет на
              телефон в виде СМС<br />
              Если сообщение с кодом не пришло, нажмите кнопку "Oтправить еще
              раз"
            </p>
          </el-row>
        </el-col>
        <el-col :span="8" class="edm-btn-block">
          <el-button
            type="success"
            size="mini"
            class="edm-btn"
            @click="onBtnClick(0, 1)"
          >
            Скачать еще раз заявку
          </el-button>
          <el-button
            type="success"
            size="mini"
            class="edm-btn"
            @click="onBtnClick(1, 0)"
          >
            Отправить еще раз
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-button
      v-if="!issued"
      type="primary"
      class="edm-check"
      @click="checkEDS"
    >
      Проверить выпуск ЭЦП
    </el-button>
    <template v-else>
      <div class="title">2. ЭЦП выпущено успешно.</div>
      <div class="indent">
        <p>
          Вы должны распечатать “Акт признания ЭЦП”, Если скачивание не началось
          автоматически. Нажмите кнопку <b>"Скачать акт признания"</b>
        </p>
        <p>
          Водитель должен Заполнить поле ФИО владельца сертификата, подписать
          Акт и передать его нам.
        </p>
        <el-button
          type="success"
          size="mini"
          class="edm-btn-act"
          @click="getAct"
        >
          Скачать акт признания
        </el-button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'IssueEDS',
  props: {
    phone: {
      type: String,
      default: '',
    },
    orgId: {
      type: Number,
      default: 0,
    },
    issued: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onBtnClick(send, download) {
      this.$emit('issue', this.phone, send, download)
    },
    checkEDS() {
      this.$emit('check', this.phone, this.orgId)
    },
    getAct() {
      this.$emit('download', this.phone)
    },
  },
}
</script>

<style lang="sass">
.emd-modal
  .edm-info
    .title
      font-weight: normal
    .indent
      padding-left: 25px
      p
        color: #8C8C8C
        font-size: 14px
        line-height: 17px
    .edm-desc
      position: relative
      height: 50px
      display: flex
      align-items: center
      flex-wrap: wrap
      margin: 0 0 15px
      padding-left: 60px
      &:before
        content: ''
        width: 45px
        height: 45px
        position: absolute
        left: 0
      &.edm-qr:before
        background: url('~@/assets/img/qr.svg')
        background-size: contain
      &.edm-sms:before
        background: url('~@/assets/img/sms.svg')
        background-size: contain
    .edm-btn-block
      display: flex
      flex-direction: column
      align-items: flex-end
      button
        margin: 15px 0
        width: 240px
    .edm-check
      margin-top: 25px
      width: 300px
    .edm-btn-act
      width: 240px
</style>
